import * as React from 'react';
import PdfPage from '@payscale/payscale-shared-ui/lib/Pdf/PdfPage';
import PdfContent from '@payscale/payscale-shared-ui/lib/Pdf/PdfContent';
import './compReportCoverPage.scss';

interface ICompReportCoverPageProps {
    employeeName: string;
}

const CompReportCoverPage = (props: ICompReportCoverPageProps): React.ReactElement => {
    return (
        <PdfPage>
            <PdfContent>
                <div className="comp-report-cover-page">
                    <div className="comp-report-cover-page__header-container">
                        <h4 className="comp-report-cover-page__title">COMPENSATION MEMO</h4>
                        <h1 className="comp-report-cover-page__employee-name">{props.employeeName}</h1>
                    </div>
                    <img alt="" src={require('contents/cover.svg')} className="comp-report-cover-page__img"/>
                </div>
            </PdfContent>
        </PdfPage>
    );
};

export default CompReportCoverPage;
export { CompReportCoverPage };